import { render, staticRenderFns } from "./u-chip-flat-tile.vue?vue&type=template&id=0f80e7bc&scoped=true&"
import script from "./u-chip-flat-tile.vue?vue&type=script&lang=js&"
export * from "./u-chip-flat-tile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80e7bc",
  null
  
)

export default component.exports